
            const data = {"name":"feather/book","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M4 19.5A2.5 2.5 0 0 1 6.5 17H20\"/><path pid=\"1\" d=\"M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z\"/>","originalColors":[],"stopColors":[]}}
        
                module.exports = data
                